// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"660442e3","453":"2fb8355c","455":"aa5fd82a","977":"44132ec8"}[chunkId] + ".chunk.js";
};